import store from '@/store'

export default [
  {
    path: '/admin/deposits',
    name: 'deposit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/accounting/deposit')
  }
]
